import { useQuery } from '@tanstack/react-query';

import { loadStateOf } from '../../../core-components/theme/components/Screen';
import type { LoadState } from '../../../core-components/theme/components/Screen';
import { mySettingsQueryOptions } from '../../close-the-loop';
import type { AlwaysReachesKey, HearLine, RoleGroup } from '../../close-the-loop';
import type { PlantScope } from '../domain/hearLines';

import { usePlantScope } from './usePlantScope';

export type HearContent =
  | { readonly kind: 'role'; readonly roleGroup: RoleGroup; readonly lines: readonly HearLine[] }
  | { readonly kind: 'unknownRole'; readonly alwaysReaches: readonly AlwaysReachesKey[] };

export interface OnboardingHear {
  readonly load: LoadState;
  readonly scope: PlantScope;
  readonly content: HearContent | null;
}

export const useOnboardingHear = (): OnboardingHear => {
  const settings = useQuery(mySettingsQueryOptions());
  const scope = usePlantScope();
  const { data } = settings;
  const roleGroup = data?.roleGroup ?? null;
  let content: HearContent | null = null;
  if (data && roleGroup !== null) content = { kind: 'role', roleGroup, lines: data.hears };
  else if (data) content = { kind: 'unknownRole', alwaysReaches: data.alwaysReaches };
  return { load: loadStateOf(settings), scope, content };
};
